<template>
  <a-breadcrumb class="breadcrumb" separator="|">
    <a-breadcrumb-item style="font-size:18px" v-if="routes.length === 2">
      {{ routes[1].name }}
    </a-breadcrumb-item>
    <a-breadcrumb-item style="font-size:14px;" v-if="routes.length === 2">
      <router-link :to="routes[0].path"> {{ routes[0].name }}</router-link>
      >
    </a-breadcrumb-item>
    <a-breadcrumb-item style="font-size:18px" v-else>
      {{ routes[0].name }}
    </a-breadcrumb-item>
  </a-breadcrumb>
</template>
<script>
export default {
  data() {
    return {
      routes: this.$route.meta,
    };
  },
  mounted() {},
};
</script>
<style lang="scss">
.breadcrumb {
  font-size: 24px;
  font-weight: 600;
  color: rgba(86, 92, 102, 1);
  height: 70px;
  line-height: 70px;
}
</style>
